import { render, staticRenderFns } from "./ClientCommercialEditModal.vue?vue&type=template&id=612e1ce8"
import script from "./ClientCommercialEditModal.vue?vue&type=script&lang=js"
export * from "./ClientCommercialEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports